window.Products.DeviceCase = {

};
window.Products.DeviceCase.DeviceCase = function() {
	
};
window.Products.DeviceCase.DeviceCase.inherits(window.Products.Product);

window.Products.DeviceCase.DeviceCase.dpi = 300;
window.Products.DeviceCase.DeviceCase.has_3d = true;

window.Products.DeviceCase.DeviceCase.prototype.set3dProperties = function(modelViewer) {
	this.updateThreeTexture(modelViewer);
	modelViewer.object.position.y = -0.75;
	modelViewer.camera.position.z = 8;
};

window.Products.DeviceCase.DeviceCase.prototype.setThreeControls = function(controls) {
	controls.minDistance = 3.5;
	controls.maxDistance = 4.5;
};

window.Products.DeviceCase.DeviceCase.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[1].material.map = modelViewer.texture;
};